\
<template>
    <div class="container contact fix-footer mt-3">
        <h2 class="pt-3">Kontakty</h2>
        <hr>
        <div class="row">
            <div class="col-md-6 margin-top ">
                <div><h3>Pastoračné centrum Anky Kolesárovej</h3></div>
                <div>Hlavná 94 Vysoká nad Uhom</div>
                <div>072 14 Pavlovce nad Uhom</div>
                <div>e-mail: <a href="mailto:domcek@domcek.org">domcek@domcek.org</a></div>
                <div>mob.: <a href="tel:+421911 912 598">0911 912 598</a></div>

                <div class="margin-lg-top"><h3>Kancelária Domčeka (prízemie TF Košice):</h3></div>
                <div>mob.: <a href="tel:+421917 350 598">0917 350 598</a></div>
                <div class="margin-lg-top"><h4>o. Pavol Hudák</h4></div>
                <div>mob.: <a href="tel:+421905 405 6745">0905 405 674</a></div>
                <div>e-mail: <a href="mailto:hudakpavol1@gmail.com">hudakpavol1@gmail.com</a></div>
                <div class="margin-lg-top"><h4>o. František Petruška</h4></div>
                <div>mob.: <a href="tel:+421940 952 412" >0940 952 412</a></div>
                <div>e-mail: <a href="mailto:ferino.petruska@gmail.com">ferino.petruska@gmail.com</a></div>
            </div>
            <div class="col-md-6 margin-top">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2637.1649144557664!2d22.085531116046294!3d48.62582617926545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4739240c6a486893%3A0x5223aa2089e9f2f3!2sDom+Anky+Koles%C3%A1rovej+(Dom%C4%8Dek)!5e0!3m2!1ssk!2ssk!4v1521831642508"
                        height="450" frameborder="0" allowfullscreen="allowfullscreen"
                        style="border: 0px; width: 100%;" title="google-maps"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Contact'
  };
</script>

<style scoped>

</style>
